import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AppCard.css';

interface AppCardProps {
  id: string;
  name: string;
  category: string;
  rating: number;
  price: number;
  icon: string;
  description: string;
}

const AppCard: React.FC<AppCardProps> = ({ id, name, category, rating, price, icon, description }) => {
  return (
    <Link to={`/app/${id}`} className="app-card">
      <div className="card-header">
        <img src={icon} alt={`${name} icon`} className="app-icon" />
        <div className="app-info">
          <h3 className="app-name">{name}</h3>
          <p className="app-category">{category}</p>
          <div className="card-meta">
            <span className="card-price">${price}/hr</span>
            {rating > 0 ? (
              <div className="rating">
                <span className="star">★</span> {rating.toFixed(1)}
              </div>
            ) : (
              <div className="rating no-rating">New</div>
            )}
          </div>
        </div>
      </div>
      <p className="app-desc">{description}</p>
      <button className="view-btn">View Profile</button>
    </Link>
  );
};

export default AppCard;
